import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import Term from "./Term";
import { LocationContext } from "./locationContext";

const GOOGLE_SHEET_API = "https://script.google.com/macros/s/AKfycbxqPNMSG1i_1cExbf0Am33c05epSTQt63mFbtbUXeiXgIIBwPEfVMP6lkn1nYk6ihSRFg/exec";

const VenueBlock = ({ location, isMobile }) => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                padding: "40px 20px",
                flexWrap: "wrap",
                backgroundColor: "#ffffff",
                marginBottom: "40px",
                borderRadius: "18px",
                boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
            }}
        >
            <div style={{ maxWidth: "480px" }}>
                <div
                    style={{
                        backgroundColor: "#843c96",
                        padding: "25px 30px",
                        borderRadius: "10px",
                        textAlign: "center",
                        marginBottom: "25px",
                        color: "white",
                        fontWeight: "700",
                        fontSize: isMobile ? "22px" : "28px",
                        lineHeight: "38px",
                    }}
                >
                    {location.name.toUpperCase()} <br />

                    <span
                        style={{
                            display: "inline-block",
                            fontWeight: "900",
                            fontSize: isMobile ? "26px" : "34px",
                            letterSpacing: "2px",

                            // Summer gradient (warm tones)
                            background:
                                "linear-gradient(90deg, #ff7a00, #ffb300, #fff200, #ff4081)",

                            WebkitBackgroundClip: "text",
                            backgroundClip: "text",
                            WebkitTextFillColor: "transparent",

                            // Glow effect (summer sunlight vibe)
                            textShadow: `
                                        0 0 8px rgba(255,122,0,0.6),
                                        0 0 16px rgba(255,179,0,0.5),
                                        0 0 24px rgba(255,64,129,0.4)
                                        `,
                        }}
                    >
                        BRANDED SUMMER SALE
                    </span>
                </div>

                <p style={{ color: "#555", textAlign: "center" }}>
                    {location.address}
                </p>

                <p
                    style={{
                        fontSize: isMobile ? "20px" : "24px",
                        fontWeight: "700",
                        textAlign: "center",
                    }}
                >
                    India's Biggest Summer Sale
                </p>

                <p style={{ fontSize: "18px", textAlign: "center" }}>
                    Date – {location.data} <br />
                    Time 10 am to 10 pm
                </p>
            </div>

            <img
                src={location.img}
                alt={location.name}
                style={{
                    width: isMobile ? "260px" : "380px",
                    height: isMobile ? "200px" : "280px",
                    objectFit: "cover",
                    borderRadius: "12px",
                    marginTop: "20px",
                    boxShadow: "0px 4px 12px rgba(0,0,0,0.25)",
                }}
                onError={(e) => (e.target.src = "/HOTEL.jpg")}
            />
        </div>
    );
};

const Venues = () => {
    const { locations } = useContext(LocationContext);

    // const loc1Data = locations.Loc1;
    // const loc2Data = locations.Loc2;
    const loc3Data = locations.Loc3;

    const navigate = useNavigate();

    const [formData, setFormData] = useState({ name: "", whatsapp: "" });
    const [couponUnlocked, setCouponUnlocked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [savedContact, setSavedContact] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [couponSaved, setCouponSaved] = useState(false);

    useEffect(() => {
        const claimed = localStorage.getItem("coupon_claimed");
        const userData = localStorage.getItem("coupon_user");
        const saved = localStorage.getItem("coupon_saved");

        if (claimed === "true" && userData) {
            setCouponUnlocked(true);
            const parsed = JSON.parse(userData);
            setSavedContact(parsed.whatsapp);
        }

        if (saved === "true") {
            setCouponSaved(true);
        }
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name.trim() || !/^[0-9]{10}$/.test(formData.whatsapp)) {
            alert("Enter valid name and 10-digit WhatsApp number");
            return;
        }

        try {
            await fetch(GOOGLE_SHEET_API, {
                method: "POST",
                mode: "no-cors",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            localStorage.setItem("coupon_claimed", "true");
            localStorage.setItem("coupon_user", JSON.stringify(formData));

            setSavedContact(formData.whatsapp);
            setCouponUnlocked(true);
        } catch (error) {
            alert("Submission failed!");
        } finally {
            setLoading(false);
        }
    };


    const takeScreenshot = async () => {
        const element = document.getElementById("coupon-card");
        if (!element) return;

        // Inject global override CSS (kills oklch)
        const style = document.createElement("style");
        style.innerHTML = `
            * {
                color: #000 !important;
                background-color: transparent !important;
                border-color: #000 !important;
                box-shadow: none !important;
            }
            #coupon-card, #coupon-card * {
                color: #fff !important;
                background: #000 !important;
            }
        `;
        document.head.appendChild(style);

        try {
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                backgroundColor: "#000",
            });

            const image = canvas.toDataURL("image/png");

            const link = document.createElement("a");
            link.href = image;
            link.download = `MEGAFASHION500-${savedContact}.png`;
            link.click();

            localStorage.setItem("coupon_saved", "true");
            setCouponSaved(true);

            setTimeout(() => {
                setShowModal(false);
            }, 500);

        } catch (err) {
            console.error("Screenshot failed:", err);
            alert("Screenshot failed. Try again.");
        }

        //Remove override CSS
        document.head.removeChild(style);
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 600);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            {/* NAV */}
            <nav
                style={{
                    display: "flex",
                    gap: "12px",
                    padding: "12px 16px",
                    background: "#f7ecfb",
                    borderRadius: "14px",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                    alignItems: "center",
                }}
            >
                <button
                    onClick={() => navigate("/")}
                    style={{
                        padding: "10px 18px",
                        fontSize: "12px",
                        fontWeight: "600",
                        borderRadius: "999px",
                        background: "linear-gradient(135deg, #b26cff, #e09af1)",
                        color: "#fff",
                        border: "none",
                        cursor: "pointer",
                        transition: "all 0.25s ease",
                        boxShadow: "0 4px 10px rgba(178,108,255,0.35)",
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow =
                            "0 8px 18px rgba(178,108,255,0.45)";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow =
                            "0 4px 10px rgba(178,108,255,0.35)";
                    }}
                >
                    Home
                </button>

                <button
                    onClick={() => navigate("/location")}
                    style={{
                        padding: "10px 18px",
                        fontSize: "12px",
                        fontWeight: "600",
                        borderRadius: "999px",
                        background: "linear-gradient(135deg, #b26cff, #e09af1)",
                        color: "#fff",
                        border: "none",
                        cursor: "pointer",
                        transition: "all 0.25s ease",
                        boxShadow: "0 4px 10px rgba(178,108,255,0.35)",
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow =
                            "0 8px 18px rgba(178,108,255,0.45)";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow =
                            "0 4px 10px rgba(178,108,255,0.35)";
                    }}
                >
                    1st Location
                </button>

                <button
                    onClick={() => navigate("/location2")}
                    style={{
                        padding: "10px 18px",
                        fontSize: "12px",
                        fontWeight: "600",
                        borderRadius: "999px",
                        background: "linear-gradient(135deg, #b26cff, #e09af1)",
                        color: "#fff",
                        border: "none",
                        cursor: "pointer",
                        transition: "all 0.25s ease",
                        boxShadow: "0 4px 10px rgba(178,108,255,0.35)",
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow =
                            "0 8px 18px rgba(178,108,255,0.45)";
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow =
                            "0 4px 10px rgba(178,108,255,0.35)";
                    }}
                >
                    2nd Location
                </button>
            </nav>

            {/* ALL VENUES */}
            <div style={{ padding: "20px" }}>
                {/* <VenueBlock location={loc1Data} isMobile={isMobile} /> */}
                {/* <VenueBlock location={loc2Data} isMobile={isMobile} /> */}
                <VenueBlock location={loc3Data} isMobile={isMobile} />
            </div>

            {/* FORM + COUPON SECTION */}
            <div
                style={{
                    backgroundColor: "#3a0051",
                    padding: "40px 20px",
                    border: "10px dotted #e53935",
                    borderRadius: "20px",
                    maxWidth: "900px",
                    margin: "40px auto",
                }}
            >
                <div
                    style={{
                        backgroundColor: "#3a0051",
                        padding: "50px 20px",
                        borderRadius: "20px",
                        textAlign: "center",
                        color: "white",
                        maxWidth: "750px",
                        margin: "auto",
                    }}
                >
                    {/* ── STEP 1: FORM ── */}
                    {!couponUnlocked ? (
                        <>
                            <h2>Submit Your Details and Get Coupon Code of</h2>
                            <h3 style={{ fontSize: "32px", marginBottom: "40px" }}>
                                Flat 500 Rs OFF
                            </h3>

                            <form
                                onSubmit={handleSubmit}
                                style={{ maxWidth: "500px", margin: "auto" }}
                            >
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Full Name"
                                    onChange={handleChange}
                                    style={{
                                        width: "100%",
                                        padding: "15px",
                                        marginBottom: "20px",
                                        borderRadius: "12px",
                                        border: "none",
                                    }}
                                />
                                <input
                                    type="text"
                                    name="whatsapp"
                                    placeholder="WhatsApp Number"
                                    onChange={handleChange}
                                    style={{
                                        width: "100%",
                                        padding: "15px",
                                        marginBottom: "20px",
                                        borderRadius: "12px",
                                        border: "none",
                                    }}
                                />
                                <button
                                    type="submit"
                                    disabled={loading}
                                    style={{
                                        backgroundColor: "#d9fff0",
                                        color: "#000",
                                        fontWeight: "600",
                                        width: "50%",
                                        padding: "15px",
                                        borderRadius: "12px",
                                        cursor: "pointer",
                                        border: "none",
                                    }}
                                >
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </form>
                        </>

                        /* ── STEP 3: CONGRATULATIONS ── */
                    ) : couponSaved ? (
                        <div style={{ textAlign: "center", padding: "20px 10px" }}>
                            <div style={{ fontSize: "70px", marginBottom: "16px" }}>🎉</div>

                            <h2
                                style={{
                                    fontSize: isMobile ? "26px" : "36px",
                                    fontWeight: "900",
                                    background:
                                        "linear-gradient(90deg, #ff1744, #ff9100, #ffea00, #00e676, #00b0ff, #d500f9)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    marginBottom: "14px",
                                    lineHeight: "1.2",
                                }}
                            >
                                Congratulations!
                            </h2>

                            <p
                                style={{
                                    fontSize: isMobile ? "16px" : "19px",
                                    color: "#ccc",
                                    marginBottom: "10px",
                                }}
                            >
                                Your coupon has been saved successfully. 🎨
                            </p>

                            <p
                                style={{
                                    fontSize: isMobile ? "15px" : "17px",
                                    color: "#aaa",
                                    marginBottom: "28px",
                                }}
                            >
                                Show this coupon at the venue to claim your{" "}
                                <strong style={{ color: "#ffea00" }}>Flat 500 Rs OFF </strong>
                            </p>

                            <div
                                style={{
                                    background: "#1a0033",
                                    border: "2px solid #843c96",
                                    borderRadius: "14px",
                                    padding: "18px 28px",
                                    display: "inline-block",
                                    marginBottom: "28px",
                                }}
                            >
                                <p style={{ margin: 0, color: "#e0aaff", fontSize: "15px" }}>
                                    📱 Registered Number:{" "}
                                    <strong style={{ color: "#fff" }}>{savedContact}</strong>
                                </p>
                            </div>

                            <br />

                            {/* Optional: let them go back to venue info */}
                            <button
                                onClick={() => navigate("/")}
                                style={{
                                    padding: "12px 32px",
                                    borderRadius: "999px",
                                    background: "linear-gradient(135deg, #b26cff, #e09af1)",
                                    color: "#fff",
                                    border: "none",
                                    cursor: "pointer",
                                    fontWeight: "600",
                                    fontSize: "15px",
                                    boxShadow: "0 4px 14px rgba(178,108,255,0.4)",
                                }}
                            >
                                🏠 Back to Home
                            </button>
                        </div>

                        /* ── STEP 2: COUPON SELECTION ── */
                    ) : (
                        <>
                            <p
                                style={{
                                    color: "#ccc",
                                    marginBottom: "24px",
                                    fontSize: "17px",
                                }}
                            >
                                🎨 Select your coupon to save:
                            </p>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: isMobile ? "column" : "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "16px",
                                }}
                            >
                                {/* Single Image */}
                                <div
                                    onClick={() => {
                                        setSelectedImage("/images/summer-sale.png"); // change here
                                        setShowModal(true);
                                    }}
                                    style={{
                                        cursor: "pointer",
                                        border: "3px solid #ff4081",
                                        borderRadius: "12px",
                                        overflow: "hidden",
                                        boxShadow: "0 4px 20px rgba(255,64,129,0.45)",
                                        transition: "transform 0.2s",
                                    }}
                                    onMouseEnter={(e) =>
                                        (e.currentTarget.style.transform = "scale(1.04)")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.transform = "scale(1)")
                                    }
                                >
                                    <img
                                        src="/images/summer-sale.png" // change here
                                        alt="Coupon"
                                        style={{
                                            width: isMobile ? "220px" : "280px",
                                            display: "block",
                                        }}
                                    />
                                </div>
                            </div>

                            <p
                                style={{
                                    color: "#aaa",
                                    marginTop: "16px",
                                    fontSize: "13px",
                                }}
                            >
                                👆 Tap to preview and save coupon
                            </p>
                        </>
                    )}
                </div>
            </div>

            {/* MODAL POPUP */}
            {showModal && (
                <div
                    onClick={() => setShowModal(false)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        background: "rgba(0,0,0,0.88)",
                        zIndex: 9999,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        padding: "20px",
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: "relative",
                            borderRadius: "16px",
                            overflow: "hidden",
                            maxWidth: "520px",
                            width: "100%",
                            boxShadow: "0 10px 40px rgba(0,0,0,0.5)",
                        }}
                    >
                        {/* COUPON CARD FOR SCREENSHOT */}
                        <div
                            id="coupon-card"
                            style={{ position: "relative", background: "#000" }}
                        >
                            <img
                                src={selectedImage}
                                alt="Selected Coupon"
                                style={{ width: "100%", display: "block" }}
                            />

                            {/* Contact badge overlay */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "8%",
                                    left: "80%",
                                    transform: "translateX(-50%)",
                                    background: "rgba(0,0,0,0.75)",
                                    color: "#fff",
                                    padding: "8px 18px",
                                    borderRadius: "20px",
                                    fontWeight: "700",
                                    fontSize: isMobile ? "12px" : "15px",
                                    letterSpacing: "0.8px",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                Valid for: {savedContact}
                            </div>
                        </div>
                    </div>

                    {/* MODAL BUTTONS */}
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            display: "flex",
                            gap: "12px",
                            marginTop: "20px",
                            width: "100%",
                            maxWidth: "520px",
                        }}
                    >
                        <button
                            onClick={takeScreenshot}
                            style={{
                                flex: 1,
                                background: "#0036a3",
                                color: "#fff",
                                padding: "14px",
                                borderRadius: "12px",
                                fontSize: isMobile ? "14px" : "16px",
                                fontWeight: "600",
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            📸 Save Coupon Screenshot
                        </button>
                        <button
                            onClick={() => setShowModal(false)}
                            style={{
                                padding: "14px 20px",
                                borderRadius: "12px",
                                background: "#555",
                                color: "#fff",
                                border: "none",
                                cursor: "pointer",
                                fontWeight: "600",
                                fontSize: isMobile ? "14px" : "16px",
                            }}
                        >
                            ✕ Close
                        </button>
                    </div>
                </div>
            )}

            <Term />
        </>
    );
};

export default Venues;